import styled from "styled-components";
import { useEffect, useState } from "react";
import { getAllSubcontractor } from "../../../services/subcontractor/get-all";
import { LoadingBackDrop } from "../../../components/loader";
import { useQuery } from "@tanstack/react-query";
import { GridColDef, GridRenderCellParams } from "@mui/x-data-grid";
import { StyledTable } from "../../../components/table/styled-table";
import { GoBackButton } from "../../../components/GoBackButton";
import { urlOperator } from "../../../utils/url";
import { Button } from "@mui/material";
import SessionService from "../../../services/session-service";
import { WarehousesContractors } from "../../../services/warehouses/get-all/types";
import { Contractor } from "../../../services/subcontractor/get-all/types";
import { SubcontractorAdresEdite } from "../operator-subcontractors-detail-edite/components/forms/adres-edite";
import { SubcontractorDataEdite } from "../operator-subcontractors-detail-edite/components/forms/data-edite";
import { OperatorSubcontractorDetailEdite } from "../operator-subcontractors-detail-edite";


export const OperatorSubcontractorsDetails = () => {

  //*Obsługa Modala-Start */
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  //*Obsługa Modala-Stop */


  const [subcontractorEdited, setSubcontractorEdited] = useState(
    {
      subcontractor_id: "",
      subcontractor_name: "",
      subcontractor_nip: "",
      subcontractor_phone: "",
      subcontractor_email: "",
      subcontractor_isActive: false,
      subcontractor_isActiveSince: null,
      subcontractor_adress_id: null,
      subcontractor_adress: {
        id_adres: "",
        kod_pocztowy: "",
        miejscowosc_poczty: "",
        miejscowosc: "",
        ulica: "",
        numer_budynku: "",
        numer_lokalu: "",
        wojewodztwo: "",
        kraj: "",
        szerokosc_geograficzna: 0,
        dlugosc_geograficzna: 0,
      },


    }
  );

  const columns: GridColDef[] = [
    {
      field: "",
      headerName: "Akcje",
      width: 120,
      sortable: false,
      filterable: false,
      hideable: false,

      renderCell: (params: GridRenderCellParams<Contractor>) => (
        < Button
          variant="contained"
          style={{
            backgroundColor: "orange",
            height: "40px",
          }}
          onClick={() => {
            handleOpen();
            setSubcontractorEdited({
              subcontractor_id: params.row.subcontractor_adress.id,
              subcontractor_name: params.row.subcontractor_adress.nazwa_wykonawcy,
              subcontractor_nip: params.row.subcontractor_adress.nip,
              subcontractor_phone: params.row.subcontractor_adress.telefon,
              subcontractor_email: params.row.subcontractor_adress.email,
              subcontractor_isActive: params.row.subcontractor_adress.aktywny,
              subcontractor_isActiveSince: null,
              subcontractor_adress_id:
                params.row.subcontractor_adress?.adres_siedziby?.id_adres
                  ? params.row.subcontractor_adress?.adres_siedziby.id_adres
                  : null,
              subcontractor_adress:
                params.row.subcontractor_adress?.adres_siedziby?.id_adres
                  ? params.row.subcontractor_adress?.adres_siedziby
                  : {
                    id_adres: "",
                    kod_pocztowy: "",
                    miejscowosc_poczty: "",
                    miejscowosc: "",
                    ulica: "",
                    numer_budynku: "",
                    numer_lokalu: "",
                    wojewodztwo: "",
                    kraj: "",
                    szerokosc_geograficzna: 0,
                    dlugosc_geograficzna: 0,
                  },

            });
          }}
        >
          Edytuj
        </Button >
      ),
    },
    { field: "subcontractor_id", headerName: "ID", width: 250 },
    { field: "subcontractor_name", headerName: "Nazwa", width: 200 },
    { field: "subcontractor_isActive", headerName: "Umowa aktywna", width: 120 },
    { field: "subcontractor_nip", headerName: "NIP", width: 110 },
    { field: "subcontractor_phone", headerName: "Telefon", width: 150 },
    { field: "subcontractor_email", headerName: "E-mail", width: 200 },
    {
      field: 'subcontractor_adress', headerName: 'Adres siedziby', width: 200,
      renderCell: (params: GridRenderCellParams<Contractor>) => (

        params.value?.adres_siedziby === null ? <div>...</div> :
          <div>
            {params.value?.adres_siedziby?.kod_pocztowy} {params.value?.adres_siedziby?.miejscowosc}
            <br />
            {params.value?.adres_siedziby?.ulica} {params.value?.adres_siedziby?.numer_budynku}
          </div>
      ),
    },
  ];

  const [subcontractors, setSubcontractors] = useState<Contractor[]>([]);

  const body = {
    paginacja: null,
  };

  const GetAllSubcontractor = useQuery(
    ["AllSubcontractor"],
    () => getAllSubcontractor(body),
    {
      refetchOnMount: true,
      refetchOnWindowFocus: false,
      onSuccess(data) {
        setSubcontractors(data.data.payload.wykonawcy);
      },
    }
  );
  const subcontractorsFromLocalStorage = SessionService.getSubcontractors();
  const subcontractorsIdArray = subcontractorsFromLocalStorage.map(
    (item: WarehousesContractors) => item.id_wykonawcy
  );
  const filteredSubcontractors: Contractor[] | undefined =
    subcontractors.filter((item: Contractor) =>
      subcontractorsIdArray.includes(item.id)
    );

  useEffect(() => { }, [filteredSubcontractors]);

  const rows = filteredSubcontractors.map((r) => ({
    id: r.id,
    subcontractor_id: r.id,
    subcontractor_name: r.nazwa_wykonawcy,
    subcontractor_isActive: r.aktywny ? "Tak" : "Nie",
    subcontractor_nip: r.nip,
    subcontractor_phone: r.telefon,
    subcontractor_email: r.email,
    subcontractor_adress: r,
  }));


  if (GetAllSubcontractor.isLoading || GetAllSubcontractor.isRefetching) {
    return <LoadingBackDrop loading={true} />;
  }
  const forms = [< SubcontractorDataEdite
    handleClose={handleClose}
    setSubcontractors={setSubcontractors}
    id={subcontractorEdited?.subcontractor_id}
    nazwa_wykonawcy={subcontractorEdited?.subcontractor_name}
    nip={subcontractorEdited?.subcontractor_nip}
    telefon={subcontractorEdited?.subcontractor_phone}
    email={subcontractorEdited?.subcontractor_email}
    aktywny={subcontractorEdited?.subcontractor_isActive}
    aktywny_data_do={subcontractorEdited?.subcontractor_isActiveSince}
    adres_id={
      subcontractorEdited?.subcontractor_adress_id
        ? subcontractorEdited?.subcontractor_adress_id
        : null}
  />,
  <SubcontractorAdresEdite
    setSubcontractors={setSubcontractors}
    handleClose={handleClose}
    id={subcontractorEdited?.subcontractor_id}
    adres_id={
      subcontractorEdited?.subcontractor_adress_id
        ? subcontractorEdited?.subcontractor_adress_id
        : null}
    adress={subcontractorEdited?.subcontractor_adress_id ? subcontractorEdited.subcontractor_adress : {
      id_adres: "",
      kod_pocztowy: "",
      miejscowosc_poczty: "",
      miejscowosc: "",
      ulica: "",
      numer_budynku: "",
      numer_lokalu: "",
      wojewodztwo: "",
      kraj: "",
      szerokosc_geograficzna: 0,
      dlugosc_geograficzna: 0,
    }} />
  ]

  return (
    <>
      <OrdersContainer>
        <ViewNavigation>
          <Redirect>
            <GoBackButton
              description={"Powrót"}
              goToUrl={urlOperator.subcontractors}
            />
          </Redirect>
        </ViewNavigation>
        <TableContainer>
          <StyledTable
            getRowId={(row) => row?.id}
            rows={rows}
            columns={columns}
            pageSize={5}
            rowsPerPageOptions={[5]}
            autoHeight
            autoPageSize
          />
        </TableContainer>
      </OrdersContainer>


      {/* Modal do Edycji*/}
      <OperatorSubcontractorDetailEdite
        open={open}
        handleOpen={handleOpen}
        handleClose={handleClose}
        forms={forms}
      />
    </>
  )
};
const OrdersContainer = styled.div`
  width: 100%-300px;
  display: flex;
  flex-direction: column;
  margin-left: ${window.screen.width > 1024 ? "350px" : "0"};
  padding-right: ${window.screen.width > 1024 ? "50px" : "0"};
  `;
const TableContainer = styled.div``;
const ViewNavigation = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  @media (max-width: 340px) {
  flex-direction: column;
  }
    `;

const Redirect = styled.div`
  display: flex;
  align-items: center;
  padding-bottom: 24px;
  `;